import { theme, VStack } from '@bpba/ui-components';
import { MenuBar } from '../../menu/MenuBar';
import { useShrink } from '../useShrink';
import { StyledBox } from '../StyledBox';
import { ReactNode } from 'react';
import { APP_TITLE } from '../../../constants/data';
import { useScrolltoContent } from '../useScrolltoContent';
import { HOME_FULL_URL } from '../../../constants/urls';
import styled from 'styled-components';
import { color, ColorProps, typography, TypographyProps, margin, MarginProps, WidthProps, width } from 'styled-system';

type Props = {
  children: ReactNode;
};

export const Layout = ({ children }: Props) => {
  useScrolltoContent();
  const { shrink } = useShrink();

  const showLogout = localStorage.getItem('token') !== null;

  return (
    <StyledBox
      minHeight={'600px'}
      maxWidth={['1152px']}
      width={'100%'}
      px={['16px', '59px', null, null, '0px']}
      margin={'auto'}
      marginTop={shrink ? ['165px', '200px'] : ['0px', null, null, null, '48px']}
      marginBottom={['24px', null, null, null, '48px']}
    >
      <VStack>
        <StyledAnchor
          href={HOME_FULL_URL}
          tabIndex={0}
          fontWeight={'500'}
          fontSize={['24px', '28px']}
          lineHeight={['26px', '32px']}
          color="primary.0"
          margin={0}
          width="fit-content"
        >
          {APP_TITLE}
        </StyledAnchor>
        {showLogout && <MenuBar />}
        <VStack padding={'24px 0px'} margin={'0px auto'}>
          {children}
        </VStack>
      </VStack>
    </StyledBox>
  );
};

type StyledAnchorProps = TypographyProps & ColorProps & MarginProps & WidthProps;
const StyledAnchor = styled.a<StyledAnchorProps>(typography, color, margin, width, {
  textDecoration: 'none',
  '&:visited': {
    color: theme.colors.primary[0],
  },
});
